import { QueryClientProvider } from '@tanstack/react-query'
import { useLayoutEffect } from 'react'
import { Router } from './router/routes'
import { setGraphClientAuthToken } from './services/graph-client'
import { client } from './services/query-client'
import { useGlobalStore } from './store/global-store'

export function App() {
  useLayoutEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)

    const myUserId = searchParams.get('myUserId')
    const liveId = searchParams.get('liveId')
    const liveUserId = searchParams.get('liveUserId')
    const liveCountry = searchParams.get('liveCountry')
    const token = searchParams.get('token')
    const isStreamer = searchParams.get('isStreamer')

    if (myUserId) {
      localStorage.setItem('@myUserId', myUserId)
      useGlobalStore.setState({ myUserId: Number(myUserId) })
    }

    if (liveId) {
      localStorage.setItem('@liveId', liveId)
      useGlobalStore.setState({ liveId: Number(liveId) })
    }

    if (liveUserId) {
      localStorage.setItem('@liveUserId', liveUserId)
      useGlobalStore.setState({ liveUserId: Number(liveUserId) })
    }

    if (liveCountry) {
      localStorage.setItem('@liveCountry', liveCountry)
      useGlobalStore.setState({ liveCountry })
    }

    if (token) {
      localStorage.setItem('@token', token)
      setGraphClientAuthToken(token)
      useGlobalStore.setState({ token })
    }

    if (isStreamer) {
      localStorage.setItem('@isStreamer', isStreamer)
      useGlobalStore.setState({ isStreamer: isStreamer === 'true' })
    }
  }, [])

  return (
    <QueryClientProvider client={client}>
      <Router />
    </QueryClientProvider>
  )
}
